import React, { useState, Fragment } from "react";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { fetchEdiReqRecords } from "../../store/action/ediReqRecords";
import Tooltip from "@material-ui/core/Tooltip";
import { setFlagforPopup } from "../../store/action/ediReqRecords";
function ResetRecords(props) {
  const [open, setOpen] = useState(false);
  const [dimmer, setDimmer] = useState(undefined);
  const [size, setSize] = useState(undefined);
  const shipmentID = useSelector((state) => window.shipmentId || state.isf?.shipmentID || props.shipmentId);
  const selectedRow = useSelector((state) => state.rowSelected?.selectedRow);
  const country = useSelector(
    (state) => window.shipmentCountry || state.isf?.currentJobData.shipment.countryOfBusiness || props.countryOfBusiness
  );

  const dispatch = useDispatch();
  const onModalOpen = () => {
    setOpen(true);
    setDimmer("blurring");
    setSize("tiny");
  };

  const onModalClose = () => {
    setOpen(false);
  };
  const handleUS = () => {
    if (selectedRow.requestTime) {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          0,
          selectedRow.documentType,
          shipmentID
        )
      );
    } else {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          1,
          selectedRow.documentType,
          shipmentID
        )
      );
    }
  };
  const handleGB = () => {
    if (selectedRow.requestTime) {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          0,
          selectedRow.cspType,
          shipmentID
        )
      );
    } else {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          1,
          selectedRow.cspType,
          shipmentID
        )
      );
    }
  };
  const handleCA = () => {
    if (selectedRow.requestTime) {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          0,
          selectedRow.formType,
          shipmentID,
          selectedRow
        )
      );
    } else {
      dispatch(
        fetchEdiReqRecords(
          selectedRow.requestid,
          country,
          1,
          selectedRow.formType,
          shipmentID,
          selectedRow
        )
      );
    }
  };
  const onclickhandler = () => {
    dispatch(setFlagforPopup(false));
    switch (country) {
      case "GB":
        handleGB();
        break;
      case "US":
        handleUS();
        break;
      case "CA":
        handleCA();
        break;
      default:
        break;
    }
  };
  return (
    <Fragment>
      <Modal
        onClose={onModalClose}
        onOpen={onModalOpen}
        open={open}
        dimmer={dimmer}
        size={size}
        trigger={
          <Tooltip
            title="Reset Selected Request"
            placement="top"
            arrow
            aria-label="Reset Request"
          >
            <button className="reset-button">Reset</button>
          </Tooltip>
        }
      >
        <Modal.Content>
          <Modal.Description>
            <p style={{ fontSize: "15px" }}>
              Your action will reset all your changes made to RequestID :{" "}
              <b>{selectedRow?.requestid} </b>
              from ShipmentID : <b>{shipmentID}</b>
            </p>
          </Modal.Description>
          <Header>Are you sure?</Header>
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={() => setOpen(false)}>
            Nope
          </Button>
          <Button
            content="Yes"
            labelPosition="right"
            icon="checkmark"
            onClick={onclickhandler}
            positive
          />
        </Modal.Actions>
      </Modal>
    </Fragment>
  );
}

export default ResetRecords;
